import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

interface Props {
  width?: number | string;
  height?: number | string;
  className?: string;
  containerClassName?: string;
}
const CustomSkeleton: FC<Props> = ({
  width,
  height,
  className,
  containerClassName
}) => {
  return (
    <Skeleton
      width={width}
      height={height}
      className={className}
      containerClassName={containerClassName}
    />
  );
  // TODO: replace react-loading-skeleton with custom implementation
  // return (
  //   <div
  //     style={{ width: width ?? 'auto', height: height ?? 'auto' }}
  //     className={cn(
  //       'block mv-2 font-light leading-relaxed bg-silver rounded-md animate-pulse',
  //       className
  //     )}
  //   >
  //     &nbsp;
  //   </div>
  // );
};

export default CustomSkeleton;
